import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Icon = styled.span`
  color: ${COLOR.GUNSMOKE};
  font-size: 14px;
  position: relative;
  top: 3px;
  margin-left: 7px;
`;
